import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useState } from "react";
import Card from "@mui/material/Card";
import { LinearProgress, IconButton, InputAdornment, Checkbox, FormControlLabel } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import MDBox from "../components/MDBox";
import MDTypography from "../components/MDTypography";
import MDInput from "../components/MDInput";
import MDButton from "../components/MDButton";
import CoverLayout from "./authentication/components/CoverLayout";
import { ClientCall } from "../context/allotees/apiClass";
import bgImage from "../assets/house.png";
import { handleInputChange } from "../components/utilities/HandleChange";
import { MessageDisplay } from "../components/lbic_component/Message";
import "../../src/assets/CSS/index.css";

function SignIn() {
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(false);
  const [errMessage, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const submitCredentials = () => {
    if (!credentials.email || !credentials.password) {
      setErr(true);
      setMessage("Please enter your email and password.");
      return;
    }
    setLoading(true);
    setErr(false);
    ClientCall(credentials, "post", "/login", "login", callback, errCallback, dispatch, null);
  };

  const callback = () => {
    setLoading(false);
    navigate("/dashboard");
  };

  const errCallback = (response) => {
    setLoading(false);
    setErr(true);
    setMessage(
      response?.response?.status === 422
        ? response.response.data.error
        : "User does not exist in our system."
    );
  };

  return (
    <CoverLayout image={bgImage} urlText="Register" link="/authentication/register">
      <Card className="w-50 sign-in shadow-sm" style={{ borderRadius: "12px", padding: "30px" }}>
        <MDBox py={4} px={3}>
          {loading && <LinearProgress color="success" sx={{ position: "absolute", width: "100%" }} />}
          <MessageDisplay className="small-text black-deep" open={err} message={errMessage} />
          <MDBox role="form">
            <MDBox mb={3}>
              <MDInput
                type="email"
                label="E-mail Address"
                variant="outlined"
                fullWidth
                onChange={(e) => handleInputChange(e, setCredentials, credentials)}
                name="email"
              />
            </MDBox>
            <MDBox mb={3}>
              <MDInput
                type={showPassword ? "text" : "password"}
                label="Password"
                variant="outlined"
                fullWidth
                onChange={(e) => handleInputChange(e, setCredentials, credentials)}
                name="password"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={togglePasswordVisibility} edge="end">
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </MDBox>
            <MDBox display="flex" justifyContent="space-between" alignItems="center">
              <FormControlLabel
                control={<Checkbox checked={rememberMe} onChange={() => setRememberMe(!rememberMe)} color="success" />}
                label="Remember Me"
              />
              <Link to="/authentication/reset-password/index.js" style={{ textDecoration: "none", color: "#4caf50" }}>
                Forgot Password?
              </Link>
            </MDBox>
            <MDBox mt={4} className="d-flex flex-column align-items-center">
              <MDButton
                variant="contained"
                color="success"
                size="large"
                onClick={submitCredentials}
                sx={{ width: "100%" }}
                disabled={loading}
              >
                {loading ? "Logging in..." : "Log in"}
              </MDButton>
            </MDBox>
            <MDBox mt={3} textAlign="center">
              <MDTypography variant="body2" color="text.secondary">
                Don't have an account? {" "}
                <MDTypography
                  component={Link}
                  to="/authentication/register"
                  variant="body2"
                  color="success"
                  fontWeight="medium"
                  sx={{ textDecoration: "none" }}
                >
                  Register
                </MDTypography>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </CoverLayout>
  );
}

export default SignIn;